<template>
  <div v-loading="state.loading"
    class="sidebar-aside">
    <skill-editor
      :visible.sync="creating"
      @input="save"></skill-editor>
    <div class="sidebar-slide" :class="{'is-active': active}">
      <div class="sidebar">
        <el-dropdown ref="dropdown"
          class="sidebar-skills" type="default"
          trigger="click" placement="bottom">
          <h1>
            <span v-if="!viewObj">Select a Skill</span>
            <span v-else-if="skill !== 'global'">Skill {{viewObj.data.name}}</span>
            <span v-else>Global items</span>
            <i class="el-icon-caret-bottom el-icon--right"></i>
          </h1>
          <el-dropdown-menu slot="dropdown" class="sidebar-menu">
            <el-button-group>
              <el-input
                placeholder="Search skill"
                v-model="search"
                autocomplete="on" class="search-skill">
              </el-input>
              <el-button type="info" icon="el-icon-search"></el-button>
            </el-button-group>
            <p>
              <ul>
                <li style="margin-bottom: 0.5em" v-show="!search">
                  <span class="sidebar-count">&nbsp;-&nbsp;&nbsp;</span>
                  <router-link class="sidebar-name"
                    :to="{name: 'global', query: $route.query }"
                    @click.native="closeDropdown"
                    >Global item</router-link>
                </li>
                <li v-for="skill in searchList" :key="skill.skill">
                  <span class="sidebar-count"
                    >({{ skill.count || '-' }}) </span>
                  <i :class="!skill.published&&!skill.approved?'el-icon-circle-plus-outline':(skill.published||skill.approved)!==skill.timestamp?'el-icon-warning-outline':'el-icon-circle-check'"></i>
                  <router-link
                    :to="{name: 'skill', params: {skill: skill.skill}, query: $route.query}"
                    @click.native="closeDropdown"
                    class="sidebar-name"
                    >
                      <span class="sidebar-skill-left">{{ skill.left }}</span>
                      <strong class="sidebar-skill-match">{{ skill.match }}</strong>
                      <span class="sidebar-skill-right">{{ skill.right }}</span>
                    </router-link>
                </li>
                <li style="margin-top: 0.5em">
                  <span class="sidebar-count">... </span>
                  <router-link class="sidebar-name"
                    :to="{name: 'home', query: $route.query}"
                    @click.native="closeDropdown"
                    >All skills</router-link>
                </li>
              </ul>
            </p>
            <div style="text-align: center;">
              <a class="el-button sidebar-button"
                href="#" @click.prevent="createSkill"
                >New skill
              </a>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="sidebar-detail" v-if="viewObj">
          <el-collapse v-model="mainCollapse" accordion>
            <el-collapse-item name="intents" v-if="listIntents">
              <h3 slot="title">Intents</h3>
              <div class="sidebar-list">
                <div class="sidebar-item" style="margin-top: 0.5em; margin-bottom: 1em">
                  <span class="sidebar-count"
                    >&nbsp;+&nbsp;&nbsp;</span>
                  <router-link
                    :to="{name: 'intent', params: {skill: skill, intent: 'new'}}"
                    class="sidebar-name sidebar-new"
                    ><em>New intent</em></router-link>
                </div>
              </div>
              <el-collapse v-model="contextCollapse" accordion>
                <el-collapse-item class="sidebar-intents"
                  v-for="context in listIntents" :key="context.context"
                  :name="context.context">
                  <h3 slot="title">
                    <span v-if="!context.context">Global context</span>
                    <span v-else-if="context.context === '#'">Special intents</span>
                    <span v-else>{{context.context}}</span>
                  </h3>
                  <el-tree class="sidebar-list"
                    :data="context.intents" accordion
                    v-if="context.intents.length">
                    <template v-slot="{ data: intent }">
                      <div class="sidebar-item">
                        <template v-if="intent.type==='node'">
                          <span class="sidebar-count"
                            >&nbsp;&gt;&nbsp;</span>
                          <span class="sidebar-node sidebar-name">
                            {{intent.shortName}}
                          </span>
                        </template>
                        <template v-else>
                          <span class="sidebar-count"
                            >({{ intent.inputs_count || intent.inputsCount || '-' }}) </span>
                          <i :class="!intent.published&&!intent.approved?'el-icon-circle-plus-outline':(intent.published||intent.approved)!==intent.timestamp?'el-icon-warning-outline':'el-icon-circle-check'"></i>
                          <span class="sidebar-followup"
                            v-if="intent.followup">⮡</span>
                          <router-link @click.native.stop
                            :to="{name: 'intent', params: {skill: skill, intent: intent.intent}, query: $route.query}"
                            class="sidebar-name"
                            >{{intent.shortName}}</router-link>
                        </template>
                      </div>
                    </template>
                  </el-tree>
                  <div class="sidebar-list" v-if="context.context !== '#'">
                    <div class="sidebar-item" style="margin-top: 0.5em">
                      <span class="sidebar-count"
                        >&nbsp;+&nbsp;&nbsp;</span>
                      <router-link
                        :to="{name: 'intent', params: {skill: skill, intent: 'new'}, query: {context: context.context || undefined}}"
                        class="sidebar-name sidebar-new"
                        ><em>New intent</em></router-link>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-collapse-item>
            <el-collapse-item name="entities">
              <h3 slot="title">Entities</h3>
              <el-tree class="sidebar-list"
                :data="localEntities" accordion
                v-if="localEntities.length">
                <template v-slot="{ data: entity }">
                  <div class="sidebar-item">
                    <template v-if="entity.type==='node'">
                      <span class="sidebar-count"
                        >&lt;{{ entity.children.length }}&gt;</span>
                      <span class="sidebar-node sidebar-name">
                        {{entity.shortName}}
                      </span>
                    </template>
                    <template v-else>
                      <span class="sidebar-count"
                        >({{ entity.count || '-' }}) </span>
                      <i :class="!entity.published&&!entity.approved?'el-icon-circle-plus-outline':(entity.published||entity.approved)!==entity.timestamp?'el-icon-warning-outline':'el-icon-circle-check'"></i>
                      <router-link @click.native.stop
                        :to="{name: 'entity', params: {skill: skill, entity: entity.entity}, query: $route.query}"
                        class="sidebar-name"
                        >{{entity.shortName}}</router-link>
                    </template>
                  </div>
                </template>
              </el-tree>
              <div class="sidebar-list">
                <div class="sidebar-item" style="margin-top: 0.5em">
                  <span class="sidebar-count"
                    >&nbsp;+&nbsp;&nbsp;</span>
                  <router-link
                    :to="{name: 'entity', params: {skill: skill, entity: 'new'}}"
                    class="sidebar-name sidebar-new"
                    ><em>New entity</em></router-link>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="synonyms">
              <h3 slot="title">Synonyms</h3>
              <el-tree class="sidebar-list"
                :data="localSynonyms" accordion
                v-if="localSynonyms.length">
                <template v-slot="{ data: synonym }">
                  <div class="sidebar-item">
                    <template v-if="synonym.type==='node'">
                      <span class="sidebar-count"
                        >&lt;{{ synonym.children.length }}&gt;</span>
                      <span class="sidebar-node sidebar-name">
                        {{synonym.shortName}}
                      </span>
                    </template>
                    <template v-else>
                      <span class="sidebar-count"
                        >({{ synonym.count || '-' }}) </span>
                      <i :class="!synonym.published&&!synonym.approved?'el-icon-circle-plus-outline':(synonym.published||synonym.approved)!==synonym.timestamp?'el-icon-warning-outline':'el-icon-circle-check'"></i>
                      <router-link @click.native.stop
                        :to="{name: 'synonym', params: {skill: skill, synonym: synonym.synonym}, query: $route.query}"
                        class="sidebar-name"
                        >{{synonym.shortName}}</router-link>
                    </template>
                  </div>
                </template>
              </el-tree>
              <div class="sidebar-list">
                <div class="sidebar-item" style="margin-top: 0.5em">
                  <span class="sidebar-count"
                    >&nbsp;+&nbsp;&nbsp;</span>
                  <router-link
                    :to="{name: 'synonym', params: {skill: skill, synonym: 'new'}}"
                    class="sidebar-name sidebar-new"
                    ><em>New synonym</em></router-link>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildTree } from '../utils/compare.js'
import State from '../stores/state.js'
import SkillEditor from '../components/pages/SkillEditor.vue'
import { filterSuggestions } from '../utils/filter.js'

const SKILLS_LENGTH = 10

export default {
  components: {
    SkillEditor,
  },
  props: {
    active: Boolean,
  },
  data () {
    return {
      state: State.state,
      viewList: [],
      viewObj: null,
      search: '',
      creating: false,
      mainCollapse: 'intents',
      contextCollapse: '',
    }
  },
  computed: {
    view () { return this.$route.query.view },
    skill () {
      return this.$route.params.skill ||
      (this.state.user && this.state.user.role === 'admin' ? 'global'
        : this.viewList.length && this.viewList[0].skill)
    },
    searchList () {
      return filterSuggestions(this.search, this.viewList, 'name')
        .slice(0, SKILLS_LENGTH)
    },
    listIntents () {
      if (!this.viewObj || !this.viewObj.data.intents) return null
      let contextsd = { '': [], '#': [] }, contextsl = [], followups = {}
      for (let context of this.viewObj.data.contexts) {
        if (context.context &&
          context.context.substr(0, 'followup:'.length) === 'followup:') {
          continue
        }
        contextsd[context.context] = []
        contextsl.push(context.context)
      }
      for (let intent of this.viewObj.data.intents) {
        intent = { ...intent }
        let context = intent.context || ''
        if (intent.intent.length !== 32) context = '#'
        if (context.substr(0, 'followup:'.length) === 'followup:') {
          let parent = context.substr('followup:'.length)
          if (!(parent in followups)) followups[parent] = {}
          intent.followup = true
          followups[parent][intent.intent] = intent
        } else contextsd[context].push(intent)
      }
      contextsl.sort()
      contextsl.unshift('')
      contextsl.unshift('#')
      let children = {}
      for (let parent in followups) {
        let flu = followups[parent], intents = []
        for (let intentid in flu) {
          intents.push(flu[intentid])
        }
        children[parent] = intents
      }
      return contextsl.map((context) => {
        return {
          type: context,
          context: context,
          intents: buildTree(contextsd[context], false, children, 'intent'),
        }
      })
    },
    localEntities () {
      if (!this.viewObj) return null
      let data = (this.viewObj.data.entities || [])
      if (this.skill !== 'global') data = data.filter(x => x.local)
      return buildTree(data.map(x => { return { ...x } }), false)
    },
    localSynonyms () {
      if (!this.viewObj) return null
      let data = (this.viewObj.data.synonyms || [])
      if (this.skill !== 'global') data = data.filter(x => x.local)
      return buildTree(data.map(x => { return { ...x } }), false)
    },
  },
  inject: ['onerror'],
  created () {
    this.loadList()
    this.loadView()
  },
  watch: {
    'state.user' () {
      this.loadList()
      this.loadView()
    },
    view () {
      this.loadList()
      this.loadView()
    },
    skill () { this.loadView() },
  },
  methods: {
    loadList () {
      let view = this.view
      State.listSkills(view)
        .then(data => {
          if (view !== this.view) return
          this.viewList = data.skills.slice()
          this.viewList.sort((a, b) => (a.timestamp < b.timestamp) - (a.timestamp > b.timestamp) || (a.name > b.name) - (a.name < b.name))
        }).catch(this.onerror)
    },
    loadView () {
      let skill = this.skill, view = this.view
      if (!skill) {
        this.viewObj = null
        return
      }
      State.getSkill(skill, view, true)
        .then(data => {
          if (skill !== this.skill || view !== this.view) return
          this.viewObj = data
        }).catch(this.onerror)
    },
    createSkill () {
      this.creating = true
      this.closeDropdown()
    },
    save (value) {
      State.createSkill(value).then(data => {
        this.$message({
          message: 'Skill created',
          type: 'success',
        })
        this.$router.push({ name: 'skill', params: { skill: data.skill } })
      }).catch(this.onerror)
    },
    closeDropdown () { this.$refs.dropdown.hide() },
  },
}
</script>

<style lang="scss">
  @import "../element-variables.scss";
  @import "../variables.scss";

  .sidebar-aside {
    flex-grow: 0;
    flex-shrink: 0;
  }

  .sidebar-slide {
    width: 300px;
    height: 100vh;
    z-index: $sidebar-z-index;
  }
  .sidebar {
    // position: relative;
    // padding: 30px 0;
    display: flex;
    flex-direction: column;
    background: #F3F5F9;
    width: 300px;
    height: 100%;
  }
  .sidebar .el-tree-node__content {
    height: auto;
    > .el-tree-node__expand-icon {
      padding: 0 2px;
      margin-left: -16px;
    }
    &:hover {
      background: transparent;
    }
  }
  .sidebar-skills {
    flex-grow: 0;
    flex-shrink: 0;
  }
  .sidebar-detail {
    flex-grow: 1;
    flex-shrink: 1;
    overflow-y: auto;
  }

  .sidebar-skills.el-dropdown {
    display: block;

    h1 {
      font-size: 22px;
      text-align: center;
      color: $--color-text-primary;
    }
  }

  .sidebar-name:not(.sidebar-node) {
    color: $--color-text-regular;
    /*font-weight: bold;*/
    text-decoration: none;
  }
  .sidebar-name:not(.sidebar-node):hover {
    text-decoration: underline;
  }
  .sidebar-name.sidebar-node {
    color: $--color-text-placeholder;
  }
  .sidebar-menu {
    padding: 10px
  }
  .sidebar, .sidebar-menu {
    .el-icon-circle-check {
      color: $--color-success;
    }
    .el-icon-circle-plus-outline {
      color: $--color-primary;
    }
    .el-icon-warning-outline {
      color: $--color-primary;
    }
  }
  .sidebar-count, .sidebar-followup {
    color: $--color-text-placeholder;
    font-family: monospace;
  }
  .sidebar ul, .sidebar-menu ul {
    list-style-type: none;
    font-size: initial;
    line-height: initial;
    padding-left: 10px;
  }
  .sidebar-list, .sidebar-list.el-tree {
    font-size: initial;
    line-height: initial;
    background: transparent;
    margin-left: 20px;
  }
  .sidebar-menu.el-dropdown-menu {
    padding: 10px;
  }
  .sidebar-menu li {
    margin-top: 0.2em;
    margin-bottom: 0.2em;
  }

  .sidebar {
    .el-collapse-item__wrap {
      background: none;
    }
    .el-collapse-item__header {
      background: none;
    }
    .el-collapse-item__content {
      padding-bottom: 20px;
    }
    .el-collapse {
      border: none;
    }
  }

  .sidebar-intents {
    .el-collapse {
      border: none;
    }
    .el-collapse-item__wrap {
      border: none;
    }
    .el-collapse-item__header {
      border: none;
    }
  }

  .sidebar-detail {
    padding: 0 20px;
  }
  .sidebar-intents {
    .el-collapse-item__header {
      margin-left: 20px;
      height: 32px;
      line-height: 32px;
    }
  }
  .sidebar h3 {
    font-size: 16px;
  }
  .sidebar-intents h3 {
    font-weight: normal;
  }

  @media (max-width: 1100px) {
    .sidebar-aside {
      flex: 0 0 0;
      .sidebar-slide {
        position: absolute;
        box-shadow: 3px 0 5px -2px rgba(175, 177, 179, 0.8);
        overflow-x: hidden;
        -webkit-transition: all .3s linear 0s;
        transition: all .3s linear 0s;
        .sidebar {
          -webkit-transition: all .3s linear 0s;
          transition: all .3s linear 0s;
        }
        &:not(.is-active) {
          width: 0;
          .sidebar {
            margin-left: -300px;
          }
        }
      }
    }
  }
</style>
